import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogIdeasIdeaEditRoute extends Route {
  model() {
    return this.modelFor('backlog.ideas.idea');
  }
}

export default instrumentRoutePerformance(BacklogIdeasIdeaEditRoute);
